import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VisaService {
  visaDetails: any;
  constructor() { }

  getVisaData() {
    return this.visaDetails;
  }

  pushVisaData(data: any) {
    this.visaDetails = data;
  }

  country_name = [
    { id: 0, code: 'BR', name: 'Brazil' },
    { id: 1, code: 'VN', name: 'Vietnam' },
    { id: 2, code: 'BS', name: 'Bahamas' },
    { id: 3, code: 'AT', name: 'Austria' },
  ]

  visaInfo = [
    {
      country: [{departName: 'New Delhi'}, {arrivalName: 'Singapore'}],
      name: 'New Delhi to Singapore',
      code: 'DEL to SIN',
      imgLoc: 'assets/b2c/visa/singapore.png',
    },
    { 
      country: [{departName: 'Chennai'}, {arrivalName: 'Vietnam'}],
      name: 'Chennai to Hanoi', 
      code: 'MAA to HAN',
      imgLoc: 'assets/b2c/visa/vietnam.png' },
    {
      country: [{departName: 'New Delhi'}, {arrivalName: 'Malaysia'}],
      name: 'New Delhi to Langkawi',
      code: 'DEL to LGK',
      imgLoc: 'assets/b2c/visa/malaysia.png',
    },
    {
      country: [{departName: 'Hyderabad'}, {arrivalName: 'Indonesia'}],
      name: 'Hyderabad to Bali',
      code: 'HYD to DPS',
      imgLoc: 'assets/b2c/visa/indonesia.png',
    },
    {
      country: [{departName: 'Mumbai'}, {arrivalName: 'Japan'}],
      name: 'Mumbai to Tokyo',
      code: 'BOM to TYO',
      imgLoc: 'assets/b2c/visa/japan.png',
    },
    {
      country: [{departName: 'Mumbai'}, {arrivalName: 'Taiwan'}],
      name: 'Mumbai to Taipei',
      code: 'BOM to TPE',
      imgLoc: 'assets/b2c/visa/taiwan.png',
    },
    {
      country: [{departName: 'New Delhi'}, {arrivalName: 'Myanmar'}],
      name: 'New Delhi to Yangon',
      code: 'DEL to RGN',
      imgLoc: 'assets/b2c/visa/myanmar.png',
    },
    {
      country: [{departName: 'New Delhi'}, {arrivalName: 'Australia'}],
      name: 'New Delhi to Sydney',
      code: 'DEL to SYD',
      imgLoc: 'assets/b2c/visa/australia.png',
    },
    {
      country: [{departName: 'Bengaluru'}, {arrivalName: 'Russia'}],
      name: 'Bengaluru to Moscow',
      code: 'BLR to MOW',
      imgLoc: 'assets/b2c/visa/russia.png',
    },
    {
      country: [{departName: 'New Delhi'}, {arrivalName: 'Türkiye'}],
      name: 'New Delhi to Istanbul',
      code: 'DEL to IST',
      imgLoc: 'assets/b2c/visa/türkiye.png',
    },
    {
      country: [{departName: 'New Delhi'}, {arrivalName: 'Georgia'}],
      name: 'New Delhi to Tbilisi',
      code: 'DEL to TBS',
      imgLoc: 'assets/b2c/visa/georgia.png',
    },
    {
      country: [{departName: 'India'}, {arrivalName: 'Cambodia'}],
      name: 'New Delhi to Battambang',
      code: 'DEL to BBM',
      imgLoc: 'assets/b2c/visa/cambodia.png',
    },
  ];
  
  countryList = [
    { name: 'Asia', list: [
      { name: "Afghanistan", code: "AF", icon: "assets/svgIcon/country-flag/af.svg" },
      { name: "Armenia", code: "AM", icon: "assets/svgIcon/country-flag/am.svg" },
      { name: "Azerbaijan", code: "AZ", icon: "assets/svgIcon/country-flag/az.svg" },
      { name: "Bahrain", code: "BH", icon: "assets/svgIcon/country-flag/bh.svg" },
      { name: "Bangladesh", code: "BD", icon: "assets/svgIcon/country-flag/bd.svg" },
      { name: "Bhutan", code: "BT", icon: "assets/svgIcon/country-flag/bt.svg" },
      { name: "Brunei", code: "BN", icon: "assets/svgIcon/country-flag/bn.svg" },
      { name: "Cambodia", code: "KH", icon: "assets/svgIcon/country-flag/kh.svg" },
      { name: "China", code: "CN", icon: "assets/svgIcon/country-flag/cn.svg" },
      { name: "Cyprus", code: "CY", icon: "assets/svgIcon/country-flag/cy.svg" },
      { name: "Georgia", code: "GE", icon: "assets/svgIcon/country-flag/ge.svg" },
      { name: "India", code: "IN", icon: "assets/svgIcon/country-flag/in.svg" },
      { name: "Indonesia", code: "ID", icon: "assets/svgIcon/country-flag/id.svg" },
      { name: "Iran", code: "IR", icon: "assets/svgIcon/country-flag/ir.svg" },
      { name: "Iraq", code: "IQ", icon: "assets/svgIcon/country-flag/iq.svg" },
      { name: "Israel", code: "IL", icon: "assets/svgIcon/country-flag/il.svg" },
      { name: "Japan", code: "JP", icon: "assets/svgIcon/country-flag/jp.svg" },
      { name: "Jordan", code: "JO", icon: "assets/svgIcon/country-flag/jo.svg" },
      { name: "Kazakhstan", code: "KZ", icon: "assets/svgIcon/country-flag/kz.svg" },
      { name: "Kuwait", code: "KW", icon: "assets/svgIcon/country-flag/kw.svg" },
      { name: "Kyrgyzstan", code: "KG", icon: "assets/svgIcon/country-flag/kg.svg" },
      { name: "Laos", code: "LA", icon: "assets/svgIcon/country-flag/la.svg" },
      { name: "Lebanon", code: "LB", icon: "assets/svgIcon/country-flag/lb.svg" },
      { name: "Malaysia", code: "MY", icon: "assets/svgIcon/country-flag/my.svg" },
      { name: "Maldives", code: "MV", icon: "assets/svgIcon/country-flag/mv.svg" },
      { name: "Mongolia", code: "MN", icon: "assets/svgIcon/country-flag/mn.svg" },
      { name: "Myanmar", code: "MM", icon: "assets/svgIcon/country-flag/mm.svg" },
      { name: "Nepal", code: "NP", icon: "assets/svgIcon/country-flag/np.svg" },
      { name: "North Korea", code: "KP", icon: "assets/svgIcon/country-flag/kp.svg" },
      { name: "Oman", code: "OM", icon: "assets/svgIcon/country-flag/om.svg" },
      { name: "Pakistan", code: "PK", icon: "assets/svgIcon/country-flag/pk.svg" },
      { name: "Palestine", code: "PS", icon: "assets/svgIcon/country-flag/ps.svg" },
      { name: "Philippines", code: "PH", icon: "assets/svgIcon/country-flag/ph.svg" },
      { name: "Qatar", code: "QA", icon: "assets/svgIcon/country-flag/qa.svg" },
      { name: "Saudi Arabia", code: "SA", icon: "assets/svgIcon/country-flag/sa.svg" },
      { name: "Singapore", code: "SG", icon: "assets/svgIcon/country-flag/sg.svg" },
      { name: "South Korea", code: "KR", icon: "assets/svgIcon/country-flag/kr.svg" },
      { name: "Sri Lanka", code: "LK", icon: "assets/svgIcon/country-flag/lk.svg" },
      { name: "Syria", code: "SY", icon: "assets/svgIcon/country-flag/sy.svg" },
      { name: "Taiwan", code: "TW", icon: "assets/svgIcon/country-flag/tw.svg" },
      { name: "Tajikistan", code: "TJ", icon: "assets/svgIcon/country-flag/tj.svg" },
      { name: "Thailand", code: "TH", icon: "assets/svgIcon/country-flag/th.svg" },
      { name: "Timor-Leste", code: "TL", icon: "assets/svgIcon/country-flag/tl.svg" },
      { name: "Turkey", code: "TR", icon: "assets/svgIcon/country-flag/tr.svg" },
      { name: "Turkmenistan", code: "TM", icon: "assets/svgIcon/country-flag/tm.svg" },
      { name: "United Arab Emirates", code: "AE", icon: "assets/svgIcon/country-flag/ae.svg" },
      { name: "Uzbekistan", code: "UZ", icon: "assets/svgIcon/country-flag/uz.svg" },
      { name: "Vietnam", code: "VN", icon: "assets/svgIcon/country-flag/vn.svg" },
      { name: "Yemen", code: "YE", icon: "assets/svgIcon/country-flag/ye.svg" }
    ]},
    { name: 'Europe', list: [
      { name: "Albania", code: "AL", icon: "assets/svgIcon/country-flag/al.svg" },
      { name: "Andorra", code: "AD", icon: "assets/svgIcon/country-flag/ad.svg" },
      { name: "Armenia", code: "AM", icon: "assets/svgIcon/country-flag/am.svg" },
      { name: "Austria", code: "AT", icon: "assets/svgIcon/country-flag/at.svg" },
      { name: "Azerbaijan", code: "AZ", icon: "assets/svgIcon/country-flag/az.svg" },
      { name: "Belarus", code: "BY", icon: "assets/svgIcon/country-flag/by.svg" },
      { name: "Belgium", code: "BE", icon: "assets/svgIcon/country-flag/be.svg" },
      { name: "Bosnia and Herzegovina", code: "BA", icon: "assets/svgIcon/country-flag/ba.svg" },
      { name: "Bulgaria", code: "BG", icon: "assets/svgIcon/country-flag/bg.svg" },
      { name: "Croatia", code: "HR", icon: "assets/svgIcon/country-flag/hr.svg" },
      { name: "Cyprus", code: "CY", icon: "assets/svgIcon/country-flag/cy.svg" },
      { name: "Czech Republic", code: "CZ", icon: "assets/svgIcon/country-flag/cz.svg" },
      { name: "Denmark", code: "DK", icon: "assets/svgIcon/country-flag/dk.svg" },
      { name: "Estonia", code: "EE", icon: "assets/svgIcon/country-flag/ee.svg" },
      { name: "Finland", code: "FI", icon: "assets/svgIcon/country-flag/fi.svg" },
      { name: "France", code: "FR", icon: "assets/svgIcon/country-flag/fr.svg" },
      { name: "Georgia", code: "GE", icon: "assets/svgIcon/country-flag/ge.svg" },
      { name: "Germany", code: "DE", icon: "assets/svgIcon/country-flag/de.svg" },
      { name: "Greece", code: "GR", icon: "assets/svgIcon/country-flag/gr.svg" },
      { name: "Hungary", code: "HU", icon: "assets/svgIcon/country-flag/hu.svg" },
      { name: "Iceland", code: "IS", icon: "assets/svgIcon/country-flag/is.svg" },
      { name: "Ireland", code: "IE", icon: "assets/svgIcon/country-flag/ie.svg" },
      { name: "Italy", code: "IT", icon: "assets/svgIcon/country-flag/it.svg" },
      { name: "Kazakhstan", code: "KZ", icon: "assets/svgIcon/country-flag/kz.svg" },
      { name: "Kosovo", code: "XK", icon: "assets/svgIcon/country-flag/xk.svg" },
      { name: "Latvia", code: "LV", icon: "assets/svgIcon/country-flag/lv.svg" },
      { name: "Liechtenstein", code: "LI", icon: "assets/svgIcon/country-flag/li.svg" },
      { name: "Lithuania", code: "LT", icon: "assets/svgIcon/country-flag/lt.svg" },
      { name: "Luxembourg", code: "LU", icon: "assets/svgIcon/country-flag/lu.svg" },
      { name: "Malta", code: "MT", icon: "assets/svgIcon/country-flag/mt.svg" },
      { name: "Moldova", code: "MD", icon: "assets/svgIcon/country-flag/md.svg" },
      { name: "Monaco", code: "MC", icon: "assets/svgIcon/country-flag/mc.svg" },
      { name: "Montenegro", code: "ME", icon: "assets/svgIcon/country-flag/me.svg" },
      { name: "Netherlands", code: "NL", icon: "assets/svgIcon/country-flag/nl.svg" },
      { name: "North Macedonia", code: "MK", icon: "assets/svgIcon/country-flag/mk.svg" },
      { name: "Norway", code: "NO", icon: "assets/svgIcon/country-flag/no.svg" },
      { name: "Poland", code: "PL", icon: "assets/svgIcon/country-flag/pl.svg" },
      { name: "Portugal", code: "PT", icon: "assets/svgIcon/country-flag/pt.svg" },
      { name: "Romania", code: "RO", icon: "assets/svgIcon/country-flag/ro.svg" },
      { name: "Russia", code: "RU", icon: "assets/svgIcon/country-flag/ru.svg" },
      { name: "San Marino", code: "SM", icon: "assets/svgIcon/country-flag/sm.svg" },
      { name: "Serbia", code: "RS", icon: "assets/svgIcon/country-flag/rs.svg" },
      { name: "Slovakia", code: "SK", icon: "assets/svgIcon/country-flag/sk.svg" },
      { name: "Slovenia", code: "SI", icon: "assets/svgIcon/country-flag/si.svg" },
      { name: "Spain", code: "ES", icon: "assets/svgIcon/country-flag/es.svg" },
      { name: "Sweden", code: "SE", icon: "assets/svgIcon/country-flag/se.svg" },
      { name: "Switzerland", code: "CH", icon: "assets/svgIcon/country-flag/ch.svg" },
      { name: "Turkey", code: "TR", icon: "assets/svgIcon/country-flag/tr.svg" },
      { name: "Ukraine", code: "UA", icon: "assets/svgIcon/country-flag/ua.svg" },
      { name: "United Kingdom", code: "GB", icon: "assets/svgIcon/country-flag/gb.svg" },
      { name: "Vatican City", code: "VA", icon: "assets/svgIcon/country-flag/va.svg" }
    ]},
    { name: 'North America', list: [
      { name: "Antigua and Barbuda", code: "AG", icon: "assets/svgIcon/country-flag/ag.svg" },
      { name: "Bahamas", code: "BS", icon: "assets/svgIcon/country-flag/bs.svg" },
      { name: "Barbados", code: "BB", icon: "assets/svgIcon/country-flag/bb.svg" },
      { name: "Belize", code: "BZ", icon: "assets/svgIcon/country-flag/bz.svg" },
      { name: "Canada", code: "CA", icon: "assets/svgIcon/country-flag/ca.svg" },
      { name: "Costa Rica", code: "CR", icon: "assets/svgIcon/country-flag/cr.svg" },
      { name: "Cuba", code: "CU", icon: "assets/svgIcon/country-flag/cu.svg" },
      { name: "Dominica", code: "DM", icon: "assets/svgIcon/country-flag/dm.svg" },
      { name: "Dominican Republic", code: "DO", icon: "assets/svgIcon/country-flag/do.svg" },
      { name: "El Salvador", code: "SV", icon: "assets/svgIcon/country-flag/sv.svg" },
      { name: "Grenada", code: "GD", icon: "assets/svgIcon/country-flag/gd.svg" },
      { name: "Guatemala", code: "GT", icon: "assets/svgIcon/country-flag/gt.svg" },
      { name: "Haiti", code: "HT", icon: "assets/svgIcon/country-flag/ht.svg" },
      { name: "Honduras", code: "HN", icon: "assets/svgIcon/country-flag/hn.svg" },
      { name: "Jamaica", code: "JM", icon: "assets/svgIcon/country-flag/jm.svg" },
      { name: "Mexico", code: "MX", icon: "assets/svgIcon/country-flag/mx.svg" },
      { name: "Nicaragua", code: "NI", icon: "assets/svgIcon/country-flag/ni.svg" },
      { name: "Panama", code: "PA", icon: "assets/svgIcon/country-flag/pa.svg" },
      { name: "Saint Kitts and Nevis", code: "KN", icon: "assets/svgIcon/country-flag/kn.svg" },
      { name: "Saint Lucia", code: "LC", icon: "assets/svgIcon/country-flag/lc.svg" },
      { name: "Saint Vincent and the Grenadines", code: "VC", icon: "assets/svgIcon/country-flag/vc.svg" },
      { name: "Trinidad and Tobago", code: "TT", icon: "assets/svgIcon/country-flag/tt.svg" },
      { name: "United States", code: "US", icon: "assets/svgIcon/country-flag/us.svg" }
    ]},
    { name: "Africa", list: [
      { name: "Algeria", code: "DZ", icon: "assets/svgIcon/country-flag/dz.svg" },
      { name: "Angola", code: "AO", icon: "assets/svgIcon/country-flag/ao.svg" },
      { name: "Benin", code: "BJ", icon: "assets/svgIcon/country-flag/bj.svg" },
      { name: "Botswana", code: "BW", icon: "assets/svgIcon/country-flag/bw.svg" },
      { name: "Burkina Faso", code: "BF", icon: "assets/svgIcon/country-flag/bf.svg" },
      { name: "Burundi", code: "BI", icon: "assets/svgIcon/country-flag/bi.svg" },
      { name: "Cabo Verde", code: "CV", icon: "assets/svgIcon/country-flag/cv.svg" },
      { name: "Cameroon", code: "CM", icon: "assets/svgIcon/country-flag/cm.svg" },
      { name: "Central African Republic", code: "CF", icon: "assets/svgIcon/country-flag/cf.svg" },
      { name: "Chad", code: "TD", icon: "assets/svgIcon/country-flag/td.svg" },
      { name: "Comoros", code: "KM", icon: "assets/svgIcon/country-flag/km.svg" },
      { name: "Democratic Republic of the Congo", code: "CD", icon: "assets/svgIcon/country-flag/cd.svg" },
      { name: "Djibouti", code: "DJ", icon: "assets/svgIcon/country-flag/dj.svg" },
      { name: "Egypt", code: "EG", icon: "assets/svgIcon/country-flag/eg.svg" },
      { name: "Equatorial Guinea", code: "GQ", icon: "assets/svgIcon/country-flag/gq.svg" },
      { name: "Eritrea", code: "ER", icon: "assets/svgIcon/country-flag/er.svg" },
      { name: "Eswatini", code: "SZ", icon: "assets/svgIcon/country-flag/sz.svg" },
      { name: "Ethiopia", code: "ET", icon: "assets/svgIcon/country-flag/et.svg" },
      { name: "Gabon", code: "GA", icon: "assets/svgIcon/country-flag/ga.svg" },
      { name: "Gambia", code: "GM", icon: "assets/svgIcon/country-flag/gm.svg" },
      { name: "Ghana", code: "GH", icon: "assets/svgIcon/country-flag/gh.svg" },
      { name: "Guinea", code: "GN", icon: "assets/svgIcon/country-flag/gn.svg" },
      { name: "Guinea-Bissau", code: "GW", icon: "assets/svgIcon/country-flag/gw.svg" },
      { name: "Ivory Coast", code: "CI", icon: "assets/svgIcon/country-flag/ci.svg" },
      { name: "Kenya", code: "KE", icon: "assets/svgIcon/country-flag/ke.svg" },
      { name: "Lesotho", code: "LS", icon: "assets/svgIcon/country-flag/ls.svg" },
      { name: "Liberia", code: "LR", icon: "assets/svgIcon/country-flag/lr.svg" },
      { name: "Libya", code: "LY", icon: "assets/svgIcon/country-flag/ly.svg" },
      { name: "Madagascar", code: "MG", icon: "assets/svgIcon/country-flag/mg.svg" },
      { name: "Malawi", code: "MW", icon: "assets/svgIcon/country-flag/mw.svg" },
      { name: "Mali", code: "ML", icon: "assets/svgIcon/country-flag/ml.svg" },
      { name: "Mauritania", code: "MR", icon: "assets/svgIcon/country-flag/mr.svg" },
      { name: "Mauritius", code: "MU", icon: "assets/svgIcon/country-flag/mu.svg" },
      { name: "Morocco", code: "MA", icon: "assets/svgIcon/country-flag/ma.svg" },
      { name: "Mozambique", code: "MZ", icon: "assets/svgIcon/country-flag/mz.svg" },
      { name: "Namibia", code: "NA", icon: "assets/svgIcon/country-flag/na.svg" },
      { name: "Niger", code: "NE", icon: "assets/svgIcon/country-flag/ne.svg" },
      { name: "Nigeria", code: "NG", icon: "assets/svgIcon/country-flag/ng.svg" },
      { name: "Rwanda", code: "RW", icon: "assets/svgIcon/country-flag/rw.svg" },
      { name: "Sao Tome and Principe", code: "ST", icon: "assets/svgIcon/country-flag/st.svg" },
      { name: "Senegal", code: "SN", icon: "assets/svgIcon/country-flag/sn.svg" },
      { name: "Seychelles", code: "SC", icon: "assets/svgIcon/country-flag/sc.svg" },
      { name: "Sierra Leone", code: "SL", icon: "assets/svgIcon/country-flag/sl.svg" },
      { name: "Somalia", code: "SO", icon: "assets/svgIcon/country-flag/so.svg" },
      { name: "South Africa", code: "ZA", icon: "assets/svgIcon/country-flag/za.svg" },
      { name: "South Sudan", code: "SS", icon: "assets/svgIcon/country-flag/ss.svg" },
      { name: "Sudan", code: "SD", icon: "assets/svgIcon/country-flag/sd.svg" },
      { name: "Tanzania", code: "TZ", icon: "assets/svgIcon/country-flag/tz.svg" },
      { name: "Togo", code: "TG", icon: "assets/svgIcon/country-flag/tg.svg" },
      { name: "Tunisia", code: "TN", icon: "assets/svgIcon/country-flag/tn.svg" },
      { name: "Uganda", code: "UG", icon: "assets/svgIcon/country-flag/ug.svg" },
      { name: "Zambia", code: "ZM", icon: "assets/svgIcon/country-flag/zm.svg" },
      { name: "Zimbabwe", code: "ZW", icon: "assets/svgIcon/country-flag/zw.svg" }
    ]},
    { name: 'Oceania', list: [
      { name: "Australia", code: "AU", icon: "assets/svgIcon/country-flag/au.svg" },
      { name: "Fiji", code: "FJ", icon: "assets/svgIcon/country-flag/fj.svg" },
      { name: "Kiribati", code: "KI", icon: "assets/svgIcon/country-flag/ki.svg" },
      { name: "Marshall Islands", code: "MH", icon: "assets/svgIcon/country-flag/mh.svg" },
      { name: "Micronesia", code: "FM", icon: "assets/svgIcon/country-flag/fm.svg" },
      { name: "Nauru", code: "NR", icon: "assets/svgIcon/country-flag/nr.svg" },
      { name: "New Zealand", code: "NZ", icon: "assets/svgIcon/country-flag/nz.svg" },
      { name: "Palau", code: "PW", icon: "assets/svgIcon/country-flag/pw.svg" },
      { name: "Papua New Guinea", code: "PG", icon: "assets/svgIcon/country-flag/pg.svg" },
      { name: "Samoa", code: "WS", icon: "assets/svgIcon/country-flag/ws.svg" },
      { name: "Solomon Islands", code: "SB", icon: "assets/svgIcon/country-flag/sb.svg" },
      { name: "Tonga", code: "TO", icon: "assets/svgIcon/country-flag/to.svg" },
      { name: "Tuvalu", code: "TV", icon: "assets/svgIcon/country-flag/tv.svg" },
      { name: "Vanuatu", code: "VU", icon: "assets/svgIcon/country-flag/vu.svg" }
    ]}
  ];

}